import React, { ComponentProps } from 'react';
import { ListingComment } from '~/api/listings';
import { categoryLabel } from '~/containers/Listings/constants';
import StaffCommentRow from '~/components/StaffCommentRow/StaffCommentRow';

type IProps = Omit<
  ComponentProps<typeof StaffCommentRow>,
  'comment' | 'badge' | 'onHide' | 'onNotifyResident' | 'onBlockUser'
> & {
  comment: ListingComment;
  onHide: (comment: ListingComment) => void;
  onNotifyResident: (comment: ListingComment) => void;
  onBlockUser?: (comment: ListingComment) => void;
};

// A Marketplace listing comment: the shared staff row, badged with its listing.
// Replies show flat here, newest first — staff moderate comments one by one.
const ListingCommentRow = (props: IProps) => (
  <StaffCommentRow<ListingComment>
    {...props}
    badge={
      <>
        {props.comment.parent ? 'Reply on ' : ''}
        {props.comment.listingTitle} ·{' '}
        {categoryLabel(props.comment.listingCategory)}
      </>
    }
  />
);

export default ListingCommentRow;
